/* TANVI contact page (sections/tanvi-contact.liquid). 2026-09-30.
   reveals on view, hero parallax, subject bar that glides under the chosen choice, growing textarea. */
(function () {
  var root = document.querySelector('[data-tv-contact]');
  if (!root || root.getAttribute('data-tv-ready')) return;
  root.setAttribute('data-tv-ready', '1');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* reveals */
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-tv-reveal]'));
  if (!reduce && 'IntersectionObserver' in window) {
    root.classList.add('is-live');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (n) { io.observe(n); });
    setTimeout(function () { items.forEach(function (n) { n.classList.add('is-in'); }); }, 4000); /* never leave anything hidden */
  }

  /* hero parallax: the photo drifts at a third of the scroll */
  var img = root.querySelector('.tv-ct__hero__img'), hero = root.querySelector('[data-tv-hero]'), ticking = false;
  function move() {
    ticking = false;
    if (!img || !hero) return;
    var r = hero.getBoundingClientRect();
    if (r.bottom < 0) return;
    var y = Math.max(0, -r.top) * 0.28;
    img.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
  }
  if (!reduce && img) {
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(move); } }, { passive: true });
    move();
  }

  /* subject bar */
  var row = root.querySelector('[data-tv-choices] .tv-ct__choice__row'), bar = root.querySelector('[data-tv-bar]');
  function placeBar() {
    if (!row || !bar) return;
    var on = row.querySelector('input:checked');
    if (!on) return;
    var span = on.nextElementSibling, rr = row.getBoundingClientRect(), sr = span.getBoundingClientRect();
    bar.style.left = (sr.left - rr.left) + 'px';
    bar.style.width = sr.width + 'px';
  }
  if (row) {
    row.addEventListener('change', placeBar);
    window.addEventListener('resize', placeBar);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeBar);
    setTimeout(placeBar, 50); setTimeout(placeBar, 600);
  }

  /* textarea grows with the text */
  Array.prototype.forEach.call(root.querySelectorAll('[data-tv-grow]'), function (t) {
    function grow() { t.style.height = 'auto'; t.style.height = t.scrollHeight + 'px'; }
    t.addEventListener('input', grow); grow();
  });

  /* ---- one question at a time (reference: sinac.co.jp/contact) ---- */
  var form = root.querySelector('.tv-ct__f'), wrap = root.querySelector('[data-tv-steps]');
  if (form && wrap) {
    var qs = Array.prototype.slice.call(wrap.querySelectorAll('.tv-ct__q'));
    var sum = wrap.querySelector('[data-tv-sum]'), sendWrap = wrap.querySelector('[data-tv-send]'), cfmWrap = wrap.querySelector('[data-tv-confirm]');
    var confirming = false, parked = null; /* parked = the question that was being answered when an earlier one was re-opened */
    function label(chip, q) { var b = chip.querySelector('.tv-ct__chip__e'); if (b && sum) b.textContent = valueOf(q) ? sum.getAttribute('data-edit') : sum.getAttribute('data-fill'); }
    var nav = wrap.querySelector('[data-tv-nav]'), navBar = wrap.querySelector('[data-tv-nav-bar]');
    var idx = -1, revising = null;
    form.classList.add('is-steps');
    form.setAttribute('novalidate', 'novalidate'); /* the steps validate; hidden required fields must not block the browser */

    function ctrl(q) { return q.querySelector('input:not([type=radio]), textarea'); }
    function chipOf(q) { return sum ? sum.querySelector('[data-chip="' + q.getAttribute('data-step') + '"]') : null; }
    function valueOf(q) {
      if (q.getAttribute('data-type') === 'choice') { var on = q.querySelector('input:checked'); return on ? on.value : ''; }
      return (ctrl(q).value || '').replace(/^\s+|\s+$/g, '');
    }
    function valid(q) {
      var v = valueOf(q);
      if (q.getAttribute('data-required') === '1' && !v) return false;
      if (q.getAttribute('data-type') === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return false;
      return true;
    }
    function appear(el) { el.classList.add('is-on'); requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-in'); }); }); }
    function hide(el) { el.classList.remove('is-on', 'is-in'); }
    /* the item list: answered = clickable, the one being answered carries the line */
    function navItem(q) { return nav ? nav.querySelector('[data-nav="' + q.getAttribute('data-step') + '"]') : null; }
    function placeBar() {
      if (!nav || !navBar) return;
      var cur = nav.querySelector('li.is-current button'); if (!cur) return;
      var nr = nav.getBoundingClientRect(), cr = cur.getBoundingClientRect();
      navBar.style.left = (cr.left - nr.left) + 'px'; navBar.style.width = cr.width + 'px';
    }
    function progress(i) {
      if (!nav) return;
      var showing = revising || qs[i];
      if (i < 0) return;
      wrap.classList.toggle('is-revising', !!revising);
      qs.forEach(function (q, k) {
        var li = navItem(q); if (!li) return;
        li.classList.toggle('is-current', q === showing && !(confirming && !revising));
        li.classList.toggle('is-done', (q !== showing || (confirming && !revising)) && valid(q) && (k < idx || (k === idx && !!valueOf(q))));
        var b = li.querySelector('button'); if (b) b.tabIndex = li.classList.contains('is-done') ? 0 : -1;
      });
      placeBar();
    }
    function focusOn(q, delay) {
      var c = ctrl(q); if (!c) return;
      setTimeout(function () { try { c.focus({ preventScroll: true }); } catch (e) { c.focus(); } }, delay);
    }
    function reveal(i, first) {
      var q = qs[i]; if (!q) return;
      idx = i; appear(q); progress(i);
      if (!first) focusOn(q, 480); /* on arrival the page must not jump to the form */
      if (q.getAttribute('data-type') === 'textarea' && valueOf(q)) showSend();
    }
    /* after the message: "review" (the answers in one list), and only there "send" */
    function showSend() { if (!confirming && cfmWrap && !cfmWrap.classList.contains('is-on')) appear(cfmWrap); }
    function enterConfirm() {
      confirming = true; revising = null;
      wrap.classList.add('is-confirm');
      if (cfmWrap) hide(cfmWrap);
      if (sendWrap) appear(sendWrap);
      progress(idx);
      try { wrap.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); } catch (e) {}
    }
    function leaveConfirm() {
      confirming = false;
      wrap.classList.remove('is-confirm');
      if (sendWrap) hide(sendWrap);
    }
    function review() {
      for (var k = 0; k < qs.length - 1; k++) { if (!valid(qs[k])) { revise(qs[k]); nudge(qs[k]); return; } }
      var q = qs[qs.length - 1];
      if (!valid(q)) { nudge(q); return; }
      var chip = chipOf(q);
      if (chip) { chip.querySelector('.tv-ct__chip__v').textContent = valueOf(q); label(chip, q); sum.classList.add('has-items'); chip.classList.add('is-on'); }
      hide(q);
      enterConfirm();
    }
    function nudge(q) {
      q.classList.add('is-nudge'); var c = ctrl(q); if (c) c.focus();
      setTimeout(function () { q.classList.remove('is-nudge'); }, 700);
    }
    /* finish a question: it shrinks and travels up into its small box */
    function complete() {
      var q = revising || qs[idx];
      if (!q) return;
      if (!valid(q)) { nudge(q); return; }
      q.classList.remove('is-error');
      var was = revising === q, next = idx + 1, chip = chipOf(q);
      function advance() {
        if (was) {
          revising = null;
          if (parked) { var p = parked; parked = null; appear(p); focusOn(p, 320); if (p.getAttribute('data-type') === 'textarea' && valueOf(p)) showSend(); } /* the question that was waiting comes back */
          progress(idx);
          return;
        }
        if (next < qs.length) reveal(next); else showSend();
      }
      if (!chip) { hide(q); advance(); return; }
      chip.querySelector('.tv-ct__chip__v').textContent = valueOf(q) || '\u2014'; /* optional and left empty */
      label(chip, q);
      var from = q.getBoundingClientRect();
      sum.classList.add('has-items'); chip.classList.add('is-on');
      hide(q);
      if (reduce) { advance(); return; }
      chip.style.transition = 'none'; chip.style.transform = 'none'; chip.style.opacity = '1';
      var to = chip.getBoundingClientRect();
      chip.style.transformOrigin = 'top left';
      chip.style.transform = 'translate(' + (from.left - to.left) + 'px,' + (from.top - to.top) + 'px) scale(' + (from.width / (to.width || 1)) + ')';
      chip.style.opacity = '0.6';
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        chip.style.transition = 'transform 0.72s cubic-bezier(0.5, 0, 0.12, 1), opacity 0.5s ease';
        chip.style.transform = 'none'; chip.style.opacity = '1';
      }); });
      setTimeout(function () { chip.style.transition = ''; chip.style.transformOrigin = ''; chip.style.transform = ''; chip.style.opacity = ''; }, 820);
      setTimeout(advance, 380);
    }
    function revise(q) {
      if (revising) return;
      if (q === qs[qs.length - 1]) { leaveConfirm(); idx = qs.length - 1; revising = null; var mc = chipOf(q); if (mc) mc.classList.remove('is-on'); appear(q); focusOn(q, 240); showSend(); progress(idx); try { q.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); } catch (e) {} return; }
      revising = q;
      /* the question that was being answered steps aside while this one is edited */
      var cur = qs[idx];
      if (!confirming && cur && cur !== q && cur.classList.contains('is-on')) { hide(cur); parked = cur; if (cfmWrap) hide(cfmWrap); }
      var chip = chipOf(q); if (chip) chip.classList.remove('is-on');
      if (sum && !sum.querySelector('.tv-ct__chip.is-on')) sum.classList.remove('has-items');
      appear(q); focusOn(q, 240); progress(idx);
      try { q.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); } catch (e) {}
    }

    qs.forEach(function (q) {
      var type = q.getAttribute('data-type'), c = ctrl(q);
      if (type === 'choice') {
        Array.prototype.forEach.call(q.querySelectorAll('input[type=radio]'), function (r) { r.checked = false; });
        q.addEventListener('click', function (e) {
          var opt = e.target.closest ? e.target.closest('.tv-ct__opt') : null; if (!opt) return;
          var r = opt.querySelector('input'); if (!r) return;
          r.checked = true;
          if (e.target === r) setTimeout(complete, 260); /* the label click re-fires on the input: act once */
        });
      } else if (type === 'textarea') {
        c.addEventListener('input', function () { if (valueOf(q)) showSend(); });
      } else {
        var composing = false;
        c.addEventListener('compositionstart', function () { composing = true; });
        c.addEventListener('compositionend', function () { composing = false; });
        c.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' && !composing && !e.isComposing && e.keyCode !== 229) { e.preventDefault(); complete(); }
        });
      }
      var go = q.querySelector('.tv-ct__go');
      if (go) go.addEventListener('click', complete);
      var skip = q.querySelector('.tv-ct__skip');
      if (skip) skip.addEventListener('click', function () { if (c) c.value = ''; complete(); });
    });
    if (sum) sum.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.tv-ct__chip__e') : null; if (!b) return;
      var key = b.parentNode.getAttribute('data-chip');
      for (var k = 0; k < qs.length; k++) { if (qs[k].getAttribute('data-step') === key) { revise(qs[k]); break; } }
    });
    if (nav) nav.addEventListener('click', function (e) {
      var li = e.target.closest ? e.target.closest('li.is-done') : null; if (!li) return;
      var key = li.getAttribute('data-nav');
      for (var k = 0; k < qs.length; k++) { if (qs[k].getAttribute('data-step') === key) { revise(qs[k]); break; } }
    });
    window.addEventListener('resize', placeBar);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeBar);
    setTimeout(placeBar, 60); setTimeout(placeBar, 700);
    if (cfmWrap) cfmWrap.querySelector('button').addEventListener('click', review);
    form.addEventListener('submit', function (e) {
      if (!confirming) { e.preventDefault(); if (idx === qs.length - 1 && !revising) review(); else complete(); return; } /* nothing is sent before the review */
      for (var k = 0; k < qs.length; k++) {
        if (!valid(qs[k])) {
          e.preventDefault();
          if (!qs[k].classList.contains('is-on')) { if (chipOf(qs[k]) && chipOf(qs[k]).classList.contains('is-on')) revise(qs[k]); else appear(qs[k]); }
          nudge(qs[k]);
          return;
        }
      }
    });
    reveal(0, true);
  }
})();
